import React, { useEffect, useState } from "react";
import { getCompanyId } from "../../../Authentication/Auth";
import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import { isMegatronFeatureOn } from "../../../Authentication/Auth";

export default (
 
) => {
 
        
  return isMegatronFeatureOn().then((megFeatureOn)=> axiosApi
    .get(`${BackendServices.USER_SERVICE.USER}/${"GetUserReport?isMegatronFeatureOn="}${megFeatureOn}`, {
     
      responseType: "blob",
      noGlobalError: true,
    })
    
    .then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `${"UserReport"} - ${new Date().toLocaleString()}.${"xlsx"}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(async (error) => {
      let errorText;
      try {
        errorText = await error.response.data.text();
      } catch (e) {
        errorText = null;
      }
      return Promise.reject(
        error.response?.status === 400 && errorText ? errorText : "Error"
      );
    }));
};
